/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Step3Inputs */

const id_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itu milik Anda selamanya!`)
};

const ms_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ia milik anda selamanya!`)
};

const da_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det er dit for evigt!`)
};

const de_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gehört für immer Ihnen!`)
};

const en_us2_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It's yours to keep forever!`)
};

const es_es2_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Es tuyo para siempre!`)
};

const es_mx2_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Es tuyo para siempre!`)
};

const fil_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iyo na ito magpakailanman!`)
};

const fr_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il est à vous pour toujours !`)
};

const it_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È tuo per sempre!`)
};

const hu_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tiéd örökre!`)
};

const nl_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is voor altijd van jou!`)
};

const no_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det er ditt for alltid!`)
};

const pl_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jest twoja na zawsze!`)
};

const pt_br2_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É seu para guardar para sempre!`)
};

const pt_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É seu para sempre!`)
};

const ro_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este al tău pentru totdeauna!`)
};

const fi_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se on sinun ikuisesti!`)
};

const sv_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det är ditt för alltid!`)
};

const vi_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nó là của bạn mãi mãi!`)
};

const tr_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonsuza kadar sizin!`)
};

const cs_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je vaše navždy!`)
};

const bg_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тя е ваша завинаги!`)
};

const ru_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Она останется у вас навсегда!`)
};

const uk_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вона залишиться з вами назавжди!`)
};

const ar_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنها ملكك إلى الأبد!`)
};

const hi_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह हमेशा के लिए आपका है!`)
};

const th_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มันจะเป็นของคุณตลอดไป!`)
};

const ja_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`永久にあなたのものです！`)
};

const zh_cn2_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它将永久属于您！`)
};

const zh_hant1_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它將永久屬於您！`)
};

const ko_misc_posts_step3 = /** @type {(inputs: Misc_Posts_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영원히 소장하세요!`)
};

/**
* | output |
* | --- |
* | "It's yours to keep forever!" |
*
* @param {Misc_Posts_Step3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_step3 = /** @type {((inputs?: Misc_Posts_Step3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Step3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_step3(inputs)
	if (locale === "ms") return ms_misc_posts_step3(inputs)
	if (locale === "da") return da_misc_posts_step3(inputs)
	if (locale === "de") return de_misc_posts_step3(inputs)
	if (locale === "en-US") return en_us2_misc_posts_step3(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_step3(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_step3(inputs)
	if (locale === "fil") return fil_misc_posts_step3(inputs)
	if (locale === "fr") return fr_misc_posts_step3(inputs)
	if (locale === "it") return it_misc_posts_step3(inputs)
	if (locale === "hu") return hu_misc_posts_step3(inputs)
	if (locale === "nl") return nl_misc_posts_step3(inputs)
	if (locale === "no") return no_misc_posts_step3(inputs)
	if (locale === "pl") return pl_misc_posts_step3(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_step3(inputs)
	if (locale === "pt") return pt_misc_posts_step3(inputs)
	if (locale === "ro") return ro_misc_posts_step3(inputs)
	if (locale === "fi") return fi_misc_posts_step3(inputs)
	if (locale === "sv") return sv_misc_posts_step3(inputs)
	if (locale === "vi") return vi_misc_posts_step3(inputs)
	if (locale === "tr") return tr_misc_posts_step3(inputs)
	if (locale === "cs") return cs_misc_posts_step3(inputs)
	if (locale === "bg") return bg_misc_posts_step3(inputs)
	if (locale === "ru") return ru_misc_posts_step3(inputs)
	if (locale === "uk") return uk_misc_posts_step3(inputs)
	if (locale === "ar") return ar_misc_posts_step3(inputs)
	if (locale === "hi") return hi_misc_posts_step3(inputs)
	if (locale === "th") return th_misc_posts_step3(inputs)
	if (locale === "ja") return ja_misc_posts_step3(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_step3(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_step3(inputs)
	return ko_misc_posts_step3(inputs)
});
export { misc_posts_step3 as "misc.posts.step3" }